module.exports = __webpack_public_path__ + "static/media/1 0 Orddiktat Intro.5d135695.mp3";